
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Nagpur District Under-11 & Under-15 Selection Chess Championship 2025</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">

        <div class="row justify-content-between">
            <div class="col-md-12">
                <p><strong>April 14, 2025</strong> Nagpur District Under-11 & Under-15 Selection Chess Championships for Open and Girls categories were successfully organized at Vivekanand Hall, Shraddha House, Kingsway, near Kasturchand Park, Nagpur. The prestigious event was conducted by Chess Association Nagpur, in association with G.H. Raisoni Sports and Cultural Foundation, MKH Sancheti Group, and Kalpana Prakash Welfare Foundation.
                </p>
                <hr>
                <h5 class="fw-bold">Tournament Champions
                </h5>
                <h6>Under-15 Open Category : </h6>
                <ul class="list-style list-style1">
                  <li><strong>Champion : </strong> Sahejveer Singh Maras – 5 points (tie-break)</li>

                  <li><strong>2nd Place : </strong> Vishwaditya Awasthi – 5 points (tie-break)</li>

                  <li><strong>3rd Place : </strong> Mohak Bhagchandani – 5 points (tie-break)</li>

                  <li><strong>4th : </strong> Yuval Mohurle – 4.5 points</li>
                </ul>
                <h6>Under-15 Girls Category :</h6>
                  <ul class="list-style list-style1">
                    <li><strong>Champion : </strong> Shraddha Bajaj – 6/6 (Perfect Score)</li>

                    <li><strong>2nd Place : </strong> Riddhi Agrawal – 5 points</li>

                    <li><strong>3rd Place : </strong> Divyanshi Khandelwal – 5 points</li>

                    <li><strong>4th : </strong> Anvi Hirde – 4 points</li>
                  </ul>
                  <h6>Under-11 Open Category :</h6>

                <ul class="list-style list-style1">
                  <li><strong>Champion : </strong> Chirag Lahoti – 5.5 points (tie-break)</li>

                  <li><strong>2nd Place : </strong> Manas Karnase – 5.5 points (tie-break)</li>

                  <li><strong>3rd Place : </strong> Rutam Zanwar – 5 points (tie-break)</li>

                  <li><strong>4th : </strong> Paris Kubde – 5 points (tie-break)</li>
                </ul>
                  <h6>Under-11 Girls Category :</h6>
                <ul class="list-style list-style1">
                  <li><strong>Champion : </strong> Swara Gandhi – 5.5 points</li>

                  <li><strong>2nd Place : </strong> Anushka Deshpande – 5 points</li>

                  <li><strong>3rd Place : </strong> Ojasvi Poharkar – 4.5 points</li>

                  <li><strong>4th : </strong> Nrutya Gurve – 4 points</li>
                </ul>
            </div>
            <!-- <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/sport/upcoming-sports/fide-rapid-rating-chess-tournament.webp"
                        alt="GHRSCF" />

                </div>
            </div> -->
        </div>
        <h5 class="fw-bold">State Representation</h5>

        <p>The top performers will proudly represent Nagpur District at the Maharashtra State Under-11 & Under-15 Open and Girls Chess Championships 2025:</p>


       <ul class="list-style list-style1">
       <li> <strong>Under-15 Open : </strong> Sahejveer Singh Maras, Vishwaditya Awasthi, Mohak Bhagchandani, Yuval Mohurle</li>

        <li><strong>Under-15 Girls : </strong> Shraddha Bajaj, Riddhi Agrawal, Divyanshi Khandelwal, Anvi Hirde</li>

       <li> <strong>Under-11 Open : </strong> Chirag Lahoti, Manas Karnase</li>

        <li><strong>Under-11 Girls : </strong> Swara Gandhi, Anushka Deshpande</li>
       </ul>
        <h5 class="fw-bold"> Prize Distribution Ceremony</h5>

        <p>The prize distribution was held in the presence of esteemed guests. Prizes were awarded by Shri Ketan Thakre, Social Worker and President of Mahalaxmi Welfare Society. The event was graced by Shri Amit Yenurkar, Director of MKH Sancheti Group, Jayant Katdhare, Former Senior Chess Player, and Bhushan Shriwas, Secretary of Chess Association Nagpur.</p>

        <h5 class="fw-bold"> Tournament Officials</h5>



       <ul class="list-style list-style1">
        <li><strong>Chief Arbiter : </strong> FA Shiva Iyer</li>

        <li><strong>Assistant Arbiters : </strong> FA Amit Tembhurne, SNA Prayas Ambade, SNA Akash Rewatkar, SNA Shyam Agrawal</li>
       </ul>
       <p>Special thanks to MKH Sancheti Group for sponsoring the prizes and to all the volunteers and organizers who ensured a smooth and successful event.</p>
       <div class="section section-md fide-chesscompetition section-banner-bg-1">
        <div class="container">

            <div class="row row-cols-1 row-cols-md-1">
                <div class="col">
                    <div class="gall-ery">
                        <div class="row">
                            <div class="col-md-7">
                                <div class="widget_title inner-title gall-sys shadow-text-sm">
                                    <h4 class="fw-bold">Photos</h4>
                                </div>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghrscf-under-nine-nineteen2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghrscf-under-nine-nineteen2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghrscf-under-nine-nineteen2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghrscf-under-nine-nineteen3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghrscf-under-nine-nineteen3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghrscf-under-nine-nineteen3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="gall-ery">
                        <div class="widget_title inner-title gall-sys shadow-text-sm">
                            <h4 class="fw-bold">Media Coverage</h4>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">

                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghrscf-under-nine-nineteen.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghrscf-under-nine-nineteen.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghrscf-under-nine-nineteen.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img
                                                src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghrscf-under-nine-nineteen1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghrscf-under-nine-nineteen1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghrscf-under-nine-nineteen1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img
                                                src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>


                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    </div>
</section>

